<template>
  <div>
    <!-- 精准配送 -->
    <div
      v-if="dInformation.deliveryWay === '1'"
      :id="'deliveryWay_' + warehouseItem.warehouseId"
      style="padding-bottom: 16px"
    >
      <span class="dib mr-8 dib-blue">
        {{ TLang("期望送达时间", "orderConfirm") }}
      </span>
      <el-date-picker
        v-model="dInformation.expectDeliveryTime"
        placeholder="请选择日期"
        :picker-options="dInformation.pickerOptions"
        align="right"
        type="date"
        :clearable="false"
        :editable="false"
        :disabled="
          epidemicDeliverInfo.allowDelivery === 0 &&
            epidemicDeliverInfo.mandatoryType === 0
        "
        @change="replyParentDate"
      ></el-date-picker>
      <el-select
        v-model="dInformation_1.expectPreciseTime"
        placeholder="请选择时间"
        :disabled="
          epidemicDeliverInfo.allowDelivery === 0 &&
            epidemicDeliverInfo.mandatoryType === 0
        "
        @change="replyParent_1_time"
      >
        <!-- <el-option
          v-for="item in dInformation.preciseDeliveryOptions"
          :key="item.value"
          :label="item.label"
          :value="item.label"
          :disabled="item.disabled"
        ></el-option> -->
        <el-option
          v-for="item in deliveryInfo_1_list[`${merchantItem.merchantNo}:${warehouseItem.warehouseNo}`]"
          :key="item.value"
          :label="item.label"
          :value="item.label"
          :disabled="item.disabled"
        ></el-option>
      </el-select>
    </div>
    <!-- 普通配送 -->
    <div v-if="dInformation.deliveryWay === '2'" style="padding-bottom: 16px">
      <span class="dib mr-8">
        {{ TLang("期望送达时间", "orderConfirm") }}
      </span>
      <!-- 目前只有一种配送时段，展示为 "工作日／周末／假日均可" -->
      <input
        class="input ml-4 input-one"
        type="text"
        :value="TLang('KDSJ', 'orderConfirm') + TLang('配送', 'orderConfirm')"
        disabled
      />
      <!-- <el-select
        v-model="dInformation.expectDeliveryTimeType"
        placeholder="工作日／周末／假日均可"
        @change="replyParent"
      >
        <el-option
          v-for="item in delliveryOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select> -->
    </div>
    <!-- 指定日期配送 -->
    <div v-if="dInformation.deliveryWay === '3'" style="padding-bottom: 16px">
      <p
        class="dib mr-8"
        style="position: relative"
      >
        <span v-if="warehouseItem.deliveryStyle == 2" class='dib-blue'>{{ TLang('预计', 'address') }}{{ TLang('发货时间', 'address') }}</span>
        <span :class="getText()==='发货时间' ? 'dib-orange' : 'dib-blue'" v-else>{{ TLang('期望', 'address') }}{{ getText() }}</span>
        <DeliveryTip
          :showTipFlag="true"
          :type="'deliveryInfo'"
          :desc="getTip()"
        ></DeliveryTip>
      </p>
      <el-date-picker
        v-model="dInformation.expectDeliveryTime"
        :placeholder="
          warehouseItem.deliveryStyle == 2 && dInformation.shipmentTime
            ? dInformation.shipmentTime
            : isPointerDefaultDay
              ? dInformation.startTime
              : TLang('请选择时间', 'orderConfirm')
        "
        :picker-options="dInformation.pickerOptions"
        align="right"
        type="date"
        :disabled="
          epidemicDeliverInfo.allowDelivery === 0 &&
            epidemicDeliverInfo.mandatoryType === 0 ||
            warehouseItem.deliveryStyle == 2
        "
        @change="
          () => {
            if (dInformation.arrivalTimeFlag !== 'Y') {
              sendGio('发货信息', '期望发货时间');
            }
            replyParent();
          }
        "
      ></el-date-picker>
      <!-- <span class="dib mr-8">{{ union_isBilingual ? '期望发货时间Delivery Schedule :' : '期望发货时间: ' }}</span> -->
      <p
        v-if="showPoint"
        style="color: #f56c6c; margin: 10px 0 0; font-size: 12px"
      >
        {{ TLang("payTime", "orderConfirm") }}
        {{
          dInformation.arrivalTimeFlag === "Y"
            ? TLang("期望送达时间", "orderConfirm")
            : TLang("期望发货时间", "orderConfirm")
        }}
      </p>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex';
import { getHourTime, formatDay, unionFlag, gioClickHandle } from '@utils';
import DeliveryTip from '@components/dfTip';
export default {
  name: 'DeliveryWay',
  components: {
    DeliveryTip,
  },
  props: {
    /**
     * deliveryWay 1 精准配送
     * deliveryWay 2 普通配送
     */
    deliveryInfo: Object,
    warehouseItem: Object,
    merchantItem: Object,
    deliveryInfo_1_list: Object,
    epidemicDeliverInfo: {
      type: Object,
      default: function() {
        return {
          allowDelivery: null,
          mandatoryType: null,
          promptWords: null,
        };
      },
    },
  },
  data() {
    return {
      dInformation: {},
      dInformation_1: {
        expectPreciseTime: '',
      },
      showTipFlag: true,
      delliveryOptions: [
        {
          label: this.TLang('KDSJ', 'orderConfirm') + TLang('配送', 'orderConfirm'),
          value: 0,
        }
      ],
      deliveryWayParameter: {},
      isPointerDefaultDay: false, // 指定日期配送并且非预售商品取默认日期 （true 表示非预售指定日期配送）
    };
  },
  computed: {
    // ...mapState('orderConfirm', ['createOrderParameter']),
    showPoint() {
      let isShow = false;
      const { deliveryWay, expectDeliveryTime, defaultPreciseDefaultDay } =
        this.dInformation;
      if (deliveryWay === '3') {
        if (this.warehouseItem.deliveryStyle == 2) {
          return false;
        }
        isShow = !!(
          (expectDeliveryTime &&
            new Date().getTime() >= new Date(expectDeliveryTime).getTime()) ||
          (!expectDeliveryTime &&
            new Date().getTime() >=
              new Date(defaultPreciseDefaultDay).getTime())
        );
      }
      return isShow;
    },
  },
  watch: {
    'dInformation.expectDeliveryTime': {
      handler(val) {
        this.setDisabled();
        if (
          val &&
          new Date(val).toDateString() === new Date().toDateString() &&
          this.dInformation.expectPreciseTime &&
          new Date().getTime() + 3 * 60 * 60 * 1000 >
            getHourTime(
              new Date().toLocaleDateString(),
              this.dInformation.expectPreciseTime,
            )
        ) {
          const index = this.dInformation.preciseDeliveryOptions.findIndex(
            (item) => !item.disabled,
          );
          this.$set(
            this.dInformation,
            'expectPreciseTime',
            this.dInformation.preciseDeliveryOptions[index].label,
          );
          this.replyParent();
        } else if (this.dInformation.deliveryWay == 3 && val) {
          // 指定日期配送，默认选中的日期触发下更新
          if (typeof val == 'string') {
            this.$set(this.dInformation, 'expectDeliveryTime', new Date(val));
            this.replyParent();
          }
        }
      },
    },
    deliveryInfo_1_list: {
      handler(a, b) {
        // console.log('deliveryInfo_1_list', a, b);
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.dInformation = Object.assign({}, this.deliveryInfo);
    // console.log(this.deliveryInfo,'传入数据---------------')
    // console.log(this.warehouseItem,'仓库信息..........')
    // 非预售商品或deliveryStyle==2 不可切换日期商品
    this.isPointerDefaultDay =
      this.warehouseItem.goodsList.findIndex((item) => !item.preSell) > -1 || this.warehouseItem.deliveryStyle == 2; //preSell 1 预售
    if (this.dInformation.deliveryWay === '1') {
      this.setDisabled();
      const index = this.dInformation.preciseDeliveryOptions.findIndex(
        (item) => !item.disabled,
      );
      // this.$set(
      //   this.dInformation,
      //   'expectPreciseTime',
      //   this.dInformation.preciseDeliveryOptions[index].label,
      // );
      // this.replyParent();
    }
  },
  methods: {
    getText() {
      // if (this.dInformation.arrivalTimeFlag === 'Y') {
      //   return this.TLang('期望送达时间', 'orderConfirm');
      // } else {
      //   return this.TLang('期望发货时间', 'orderConfirm');
      // }
      if (this.dInformation.arrivalTimeFlag === 'Y') {
        return this.TLang('送达时间', 'address');
      } else {
        return this.TLang('发货时间', 'address');
      }
    },
    getTip() {
      if (this.warehouseItem.deliveryStyle == 2) {
        return this.TLang('DeliveryTimeTips3', 'orderConfirm');
      }
      if (this.dInformation.arrivalTimeFlag === 'Y') {
        let tip = this.ReplaceText(
          'XXXX',
          formatDay(this.dInformation.expectDeliveryTime),
          this.TLang('DeliveryTimeTips', 'orderConfirm'),
        );
        return tip;
      } else {
        return this.TLang('distributionTime', 'orderConfirm');
      }
    },
    formatParameter() {
      let parameter = '';
      if (this.dInformation.deliveryWay === '1') {
        parameter = {
          deliveryWay: this.dInformation.deliveryWay,
          expectDeliveryTime: this.dInformation.expectDeliveryTime,
          expectPreciseTime: this.dInformation_1.expectPreciseTime,
        };
      }

      if (this.dInformation.deliveryWay === '2') {
        parameter = {
          deliveryWay: this.dInformation.deliveryWay,
          expectDeliveryTimeType: this.dInformation.expectDeliveryTimeType,
        };
      }

      if (this.dInformation.deliveryWay === '3') {
        parameter = {
          cutOffTimeStr: this.dInformation.cutOffTimeStr,
          deliveryWay: this.dInformation.deliveryWay,
          expectDeliveryTime: this.isPointerDefaultDay
            ? this.dInformation.expectDeliveryTime ||
              this.dInformation.defaultpreciseDefaultTime
            : this.dInformation.expectDeliveryTime,
        };
        this.saveDate(parameter);
      }

      this.deliveryWayParameter = parameter;
    },
    replyParentDate() {
      if (this.dInformation.deliveryWay === '1') {
        this.dInformation_1.expectPreciseTime = '';
        this.$emit('getDelivery_1_options', this.dInformation.expectDeliveryTime);
      }
      this.replyParent();
    },
    replyParent() {
      this.formatParameter();
      this.$emit('onResetDeliveryWay', this.deliveryWayParameter);
    },
    replyParent_1_time() {
      this.dInformation.expectPreciseTime = this.dInformation_1.expectPreciseTime;
      this.replyParent();
    },
    setDisabled() {
      const { expectDeliveryTime, preciseDeliveryOptions } = this.dInformation;
      preciseDeliveryOptions &&
        preciseDeliveryOptions.length > 0 &&
        preciseDeliveryOptions.map((item) => {
          item.disabled = !!(
            new Date(expectDeliveryTime).toDateString() ===
              new Date().toDateString() &&
            new Date().getTime() + 3 * 60 * 60 * 1000 >
              getHourTime(new Date().toLocaleDateString(), item.value)
          );
        });
    },
    // 保存上一次选中的日期
    saveDate(parameter) {
      if (!parameter.expectDeliveryTime) return;
      let year = parameter.expectDeliveryTime.getFullYear();
      let month = parameter.expectDeliveryTime.getMonth() + 1;
      month = month > 9 ? month : '0' + month;
      let date = parameter.expectDeliveryTime.getDate();
      date = date > 9 ? date : '0' + date;
      let saveDateList =
        JSON.parse(window.sessionStorage.getItem('pcDeliverWay3')) || [];
      let info = {
        warehouseId: this.warehouseItem.warehouseId,
        choosedDate: year + '-' + month + '-' + date,
      };
      let temp = saveDateList.filter(
        (item) => item.warehouseId != info.warehouseId,
      );
      saveDateList = [...temp, info];
      window.sessionStorage.setItem(
        'pcDeliverWay3',
        JSON.stringify(saveDateList),
      );
    },
    sendGio(modluename, elementname, otherParam = {}) {
      const params = {
        df_channle: unionFlag() ? '百福德' : '官网',
        df_pagename: '提交订单',
        df_modulename: modluename,
        df_elementname: elementname,
        ...otherParam,
      };
      gioClickHandle('DF_elementClick', params, 'channelGio');
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-input__inner {
  height: 30px;
  border-radius: 0;
}
/deep/ .el-input__icon {
  line-height: 30px;
}
.el-select-dropdown__item {
  padding: 0 16px;
}
.dib-orange{
  color: #FF6600;
}
.dib-blue {
  color: #3FA6FF;
}
.input-one{
    width: 225px;
}
</style>
